// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';
import { openSnackbar } from 'store/slices/snackbar';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    zones: [],
    totalZones: ''
};

const slice = createSlice({
    name: 'zone',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // ADD Zones
        addZoneSuccess(state, action) {
            state.zones = action.payload;
        },

        // GET Zones
        getzonesSuccess(state, action) {
            state.zones = action.payload.data;
            state.totalZones = action.payload.total;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
export function addZone(zone) {
    return async () => {
        try {
            await axios.post('/api/add_zone', zone);
            const response = await axios.get('/api/zone');
            dispatch(slice.actions.addZoneSuccess(response.data.data.data));
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Zone save successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Something wents wrong! please try again!',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    actionButton: false
                })
            );
        }
    };
}

export function updateZone(values, typeId) {
    return async () => {
        try {
            await axios.post(`/api/update_zone?id=${typeId}`, values);
            const response = await axios.get('/api/zone');
            dispatch(slice.actions.addZoneSuccess(response.data.data.data));
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Zone udated successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: true
                })
            );
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Something wents wrong! please try again!',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true
                })
            );
        }
    };
}
export function getzones(page, search) {
    return async () => {
        try {
            const response = await axios.get(`/api/zone?page=${page}&search=${search}`);
            dispatch(slice.actions.getzonesSuccess(response.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
